import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { BIBlue, BIRed } from "../../assets/helpers";
import { LocationOn as MapMarkerIcon } from "@mui/icons-material";
import mapMarkerBlue from "../../assets/images/marker_blue.png";
import Emptydata from "../common/Emptydata";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  FETCH_SITES_PROJECTS,
  GET_SITE_FOLLOWING_PROJECTS,
  SAVE_FOLLOWING_PROJECTS,
  SAVE_PROJECTS_COMPAINES,
  SAVE_PROJECTS_PRODUCTS
} from "../../constant/Apipath";
import {
  setProjectimages,
  setSelectedProjectdata,
  setSelectedsite,
  setSelectedSiteId,
  setShowaddexperience,
  setShowaddproject,
  setShowmapmodal,
  setShowReport,
  setSiteprojects
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { useNavigate } from "react-router-dom";
import Pages from "../../constant/ReportModel";
import { Getrequestcall } from "../../request/Getrequest";
import PromptModal from "../common/PromptModal";
import { CompanyListSkeleton } from "../skeleton/SkeletonView";

const SitesProjectSection = ({ siteId, activeTab, scrollId, siteInfo, openAddProject }) => {
  // 1. Declaration of custom hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validValues = [
    "experience",
    "company-detail",
    "product-detail",
    "manufacture-detail",
    "earn-rewards"
  ];

  //2. Get the data from redux
  const {
    multiLanguageData,
    showMapmodal,
    loginData,
    selectedProject,
    updateSiteprojects,
    reportSuccess
  } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.SiteDetail || {};
  const {
    TEXT_PROJECTS = English.SiteDetail.TEXT_PROJECTS,
    TEXT_ADD_PROJECT = English.SiteDetail.TEXT_ADD_PROJECT,
    TEXT_NO_PROJECT_ADDED_YET = English.SiteDetail.TEXT_NO_PROJECT_ADDED_YET,
    TEXT_REPORT = English.SiteDetail.TEXT_REPORT,
    TEXT_FOLLOW_ALL = English.SiteDetail.TEXT_FOLLOW_ALL,
    TEXT_FOLLOWING_ALL = English.SiteDetail.TEXT_FOLLOWING_ALL,
    TEXT_ADD_TO_PROFILE = English.SiteDetail.TEXT_ADD_TO_PROFILE,
    TEXT_ACTIVE = English.SiteDetail.TEXT_ACTIVE,
    TEXT_FOLLOW_ALERT_PROJECT = English?.SiteDetail?.TEXT_FOLLOW_ALERT_PROJECT,
    TEXT_UNFOLLOW_ALERT_PROJECT = English?.SiteDetail?.TEXT_UNFOLLOW_ALERT_PROJECT,
    TEXT_YES = English?.SiteDetail?.TEXT_YES
  } = LanguageData || {};

  const [siteProjects, setSiteProjects] = useState([]);
  const [noOfProject, setNoOfProject] = useState(null);
  const [allFollowing, setAllFollowing] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [moreProjectmenu, setMoreprojectmenu] = useState(false);
  const [removeProjectSectionAlert, setRemoveProjectSectionAlert] = useState(false);
  const [followFlag, setFollowFlag] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (activeTab === "projects" || updateSiteprojects === true) {
      fetchSiteProjects();
    }
  }, [activeTab, updateSiteprojects]);

  const fetchSiteProjects = async () => {
    setIsLoading(true);
    setPageNumber(1);
    await getSiteProjects(1);
    setIsLoading(false);
  };

  // After add report refresh the project list
  useEffect(() => {
    if (reportSuccess === true) {
      fetchSiteProjects();
    }
  }, [reportSuccess]);

  const getSiteProjects = async (pageNumber) => {
    try {
      setAllDataLoaded(true);
      let payload = {
        PageNr: pageNumber,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{ siteId: siteId }],
        SortList: [
          {
            FieldName: "id",
            Direction: "DESC"
          }
        ]
      };
      const siteProjectResponse = await Postrequestcall(
        FETCH_SITES_PROJECTS,
        payload,
        loginData?.accessToken
      );
      if (siteProjectResponse.status === 200) {
        let res = siteProjectResponse.data;
        const records = res?.data ?? [];
        setHasMore(records.length >= 10);
        if (pageNumber > 1) {
          setTimeout(() => {
            setSiteProjects((prevProducts) => [...prevProducts, ...records]);
          }, 500);
        } else {
          setSiteProjects(records);
        }
        const allFollowingRecords = records.every((record) => record?.isFollowing === true);
        setAllFollowing(allFollowingRecords);
        setNoOfProject(res?.nrOfRecords);
      }
    } catch (error) {
      console.log("getSiteProjects-> Error While Fetching Site Project: ", error);
    } finally {
      setAllDataLoaded(false);
    }
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const onGoToProfile = async (project) => {
    if (showMapmodal?.from === "experience") {
      if (localStorage.getItem("onboardingPending") === "true") {
        dispatch(
          setSelectedProjectdata({
            ...project,
            mainPictureUrl: project?.pictureList?.[0]?.pictureUrl || "",
            siteName: siteInfo?.name,
            address: siteInfo?.address,
            latitude: siteInfo.latitude,
            longitude: siteInfo.longitude,
            projectId: project?.id,
            siteId: siteInfo?.id,
            from: "experience",
            type: "add"
          })
        );
        let mapModal = {
          open: false,
          from: "",
          select: ""
        };
        dispatch(setShowmapmodal(mapModal));
        return;
      }
      dispatch(
        setSelectedProjectdata({
          ...project,
          mainPictureUrl: project?.pictureList?.[0]?.pictureUrl || "",
          siteName: siteInfo?.name,
          address: siteInfo?.address,
          latitude: siteInfo.latitude,
          longitude: siteInfo.longitude,
          projectId: project?.id,
          from: "experience",
          type: "add"
        })
      );
      dispatch(setShowaddexperience(true));
      // props?.setShowDropMarkerOnMap(false);
    } else if (showMapmodal?.from === "earn-rewards") {
      dispatch(
        setSelectedProjectdata({
          ...project,
          mainPictureUrl: project?.pictureList?.[0]?.pictureUrl || "",
          siteName: siteInfo?.name,
          address: siteInfo?.address,
          projectId: project?.id,
          from: "earn-rewards"
        })
      );
      let mapModal = {
        open: false,
        from: "",
        select: ""
      };
      dispatch(setShowmapmodal(mapModal)); // Close map modal
      // props?.setShowDropMarkerOnMap(false);
    } else if (
      showMapmodal?.from === "company-detail" ||
      showMapmodal?.from === "manufacture-detail"
    ) {
      await saveProjectForCompany(project);
    } else if (showMapmodal?.from === "product-detail") {
      saveProjectforProduct(project);
    } else if (showMapmodal?.from === "dashboard") {
      let mapModal = {
        open: false,
        from: "",
        select: ""
      };
      dispatch(setSelectedsite(null));
      dispatch(setShowmapmodal(mapModal));
      dispatch(setSelectedSiteId(0));
      navigate("/project/" + project?.id);
    } else {
      navigate("/project/" + project?.id); // navigate to project detail
    }
  };

  const saveProjectforProduct = async (project) => {
    try {
      let getProductid = window.location.pathname.split("/").pop();
      const obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: getProductid,
            ProjectId: project?.id,
            ModifiedBy: Number(loginData?.userInformation?.UserId),
            RecordStatusId: 1
          }
        ]
      };
      let getResponse = await Postrequestcall(SAVE_PROJECTS_PRODUCTS, obj, loginData?.accessToken);
      if (getResponse.status === 201) {
        closeMapmodal(project);
      }
    } catch (error) { }
  };

  const saveProjectForCompany = async (project) => {
    try {
      let getCompanyid = window.location.pathname.split("/").pop();
      const saveObj = [
        {
          Id: 0,
          ProjectId: project?.id,
          CompanyId: Number(getCompanyid),
          ModifiedBy: Number(loginData?.userInformation?.UserId)
        }
      ];
      let getResponse = await Postrequestcall(
        SAVE_PROJECTS_COMPAINES,
        saveObj,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        closeMapmodal(project);
      }
    } catch (error) {
      console.log("saveProjectForCompany-> Error When Trying To Save Project For Company: ", error);
    }
  };

  const closeMapmodal = (project) => {
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal)); // Close the map modal
    dispatch(
      setSelectedProjectdata({
        ...project,
        mainPictureUrl: project?.pictureList?.length > 0 ? project?.pictureList[0]?.pictureUrl : "",
        siteName: siteInfo?.name,
        address: siteInfo?.address,
        projectId: project?.id,
        from:
          showMapmodal?.from === "company-detail"
            ? "company-detail"
            : showMapmodal?.from === "product-detail"
              ? "product-detail"
              : "manufacture-detail"
      })
    );
  };

  // Project report
  const handleReport = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.siteProject?.name,
      AppScreenId: Pages?.siteProject?.id,
      recordId: selectedProject.projectId ?? 0
    };
    console.log("Report Object: ", reportObj);
    dispatch(setShowReport(reportObj));
    setMoreprojectmenu(false);
  };

  const handleSaveFollowClick = async (isFollow) => {
    try {
      setIsSaveLoading(true);
      const obj = {
        UserId: loginData?.userInformation?.UserId,
        SiteId: siteInfo?.id,
        IsFollowing: isFollow
      };
      let getReponse = await Postrequestcall(SAVE_FOLLOWING_PROJECTS, obj, loginData?.accessToken);
      if (getReponse.status === 201) {
        await getSiteFollowingProjects();
      }
      setIsSaveLoading(false);
    } catch (error) {
      console.log("handleSaveFollowClick-> Error When Saving Following Project: ", error);
      setIsSaveLoading(false);
    }
  };

  const getSiteFollowingProjects = async () => {
    try {
      let getResponse = await Getrequestcall(
        `${GET_SITE_FOLLOWING_PROJECTS}/${loginData?.userInformation?.UserId}/${siteInfo?.id}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        let followRes = getResponse?.data?.data?.[0];
        setAllFollowing(followRes?.isFollowing);
      }
    } catch (error) {
      console.log("getSiteFollowingProjects-> Error While Getting Site Following Project: ", error);
    }
  };

  const openProjectmenu = (event, project) => {
    dispatch(
      setSelectedProjectdata({
        ...project,
        mainPictureUrl: project?.pictureList?.length > 0 ? project?.pictureList[0]?.pictureUrl : "",
        siteName: siteInfo?.name,
        address: siteInfo?.address,
        latitude: siteInfo?.latitude,
        longitude: siteInfo?.longitude,
        projectId: project?.id
      })
    );
    setMoreprojectmenu(event.currentTarget);
  };

  const openAddExperience = () => {
    setMoreprojectmenu(false);
    dispatch(setShowaddexperience(true));
  };

  const handleFollowPressed = () => {
    setRemoveProjectSectionAlert(true);
    setFollowFlag(true);
  };

  const handleFollowingPressed = () => {
    setRemoveProjectSectionAlert(true);
    setFollowFlag(false);
  };

  const getDate = (params) => {
    let displayStartDate = params?.startDate ? moment(params?.startDate).format("MM YYYY") : "";
    let displayEndDate = params?.endDate ? moment(params?.endDate).format("MM YYYY") : "";
    let displayFinalData = null;
    if (params?.present) {
      if (displayStartDate.length !== 0) {
        displayFinalData = `${displayStartDate} - Present`;
        return displayFinalData;
      } else {
        displayFinalData = "- Present";
        return displayFinalData;
      }
    } else {
      if (displayStartDate.length !== 0 && displayEndDate.length !== 0) {
        displayFinalData = `${displayStartDate} - ${displayEndDate}`;
        return displayFinalData;
      } else if (displayStartDate.length === 0 && displayEndDate.length === 0) {
        return null;
      } else {
        displayFinalData = `${displayStartDate} - ${displayEndDate}`;
        return displayFinalData;
      }
    }
  };

  if (isLoading) {
    return <CompanyListSkeleton />;
  }

  return (
    <div>
      <Stack sx={{ gap: 1 }} >
        <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
          <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
            {/* Count Removed */}
            {siteProjects?.length !== 0 && (
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                <Icon
                  fontSize="small"
                  color="primary"
                  sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FiberManualRecordIcon fontSize="small" sx={{ fontSize: "10px" }} />
                </Icon>
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{ textTransform: "none" }}
                  onClick={allFollowing ? handleFollowingPressed : handleFollowPressed}>
                  {allFollowing ? TEXT_FOLLOWING_ALL : TEXT_FOLLOW_ALL}
                </Button>
              </Stack>
            )}
          </Stack>
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            color="primary"
            onClick={() => openAddProject()}>
            {TEXT_ADD_PROJECT}
          </Button>
        </Stack>

        {siteProjects.length !== 0 ? (
          <InfiniteScroll
            dataLength={siteProjects?.length}
            next={async () => {
              increaseOffset((pageNumber) => {
                getSiteProjects(pageNumber);
              });
            }}
            hasMore={hasMore}
            loader={
              !allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </h4>
              )
            }
            scrollableTarget={scrollId}>
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                <Menu
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  style={{ top: "12px", left: "10px" }}
                  anchorEl={moreProjectmenu}
                  open={Boolean(moreProjectmenu)}
                  onClose={(event) => {
                    setMoreprojectmenu(false);
                  }}>
                  {!validValues.includes(showMapmodal?.from) ? (
                    <MenuItem style={{ color: BIBlue }} dense onClick={() => openAddExperience()}>
                      {TEXT_ADD_TO_PROFILE}
                    </MenuItem>
                  ) : null}
                  <MenuItem onClick={() => handleReport()} style={{ color: BIRed }} dense>
                    {TEXT_REPORT}
                  </MenuItem>
                </Menu>
                {siteProjects?.map((project, index) => (
                  <Card key={index.toString()} className="pagelist-content">
                    <ListItem
                      sx={{ m: 0, p: 0 }}
                      secondaryAction={
                        <>
                          {project?.addToProfileList?.length !== 0 ? (
                            <IconButton disabled>
                              <img src={mapMarkerBlue} alt="Map Marker Blue" height={"25px"} />
                            </IconButton>
                          ) : (
                            <></>
                          )}
                          {showMapmodal?.from !== "earn-rewards" && (
                            <IconButton onClick={(event) => openProjectmenu(event, project)}>
                              <MoreHorizIcon />
                            </IconButton>
                          )}
                        </>
                      }
                      disablePadding>
                      <ListItemButton onClick={() => onGoToProfile(project)}>
                        <ListItemAvatar>
                          <Avatar
                            variant="square"
                            alt="Site-PictureUrl"
                            style={{
                              cursor: "pointer",
                              width: "65px",
                              height: "50px",
                              borderRadius: "5px",
                              border: "1px gray solid"
                            }}
                            src={
                              project?.pictureList?.length > 0
                                ? project?.pictureList?.[0]?.thumbUrl
                                : PlaceholderImg
                            }
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{ ml: 2, mb: 0 }}
                          primary={
                            <Typography variant="body1" maxWidth={"250px"} noWrap>
                              {project?.projectName}
                            </Typography>
                          }
                          secondary={
                            <Stack spacing={0.5}>
                              {project?.isActive ? (
                                <span> {<Chip label={TEXT_ACTIVE} />} </span>
                              ) : null}
                              <Stack>{getDate(project)}</Stack>
                            </Stack>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                ))}
              </Stack>
            </List>
          </InfiniteScroll>
        ) : (
          <Box className="empty-data-card" sx={{ pt: 5 }}>
            <Emptydata
              icon={<MapMarkerIcon className="emptydata-icon" />}
              firstText={TEXT_NO_PROJECT_ADDED_YET}
            />
          </Box>
        )}
      </Stack>
      <PromptModal
        isOpen={removeProjectSectionAlert}
        onClose={() => {
          setRemoveProjectSectionAlert(false);
        }}
        title={followFlag ? TEXT_FOLLOW_ALERT_PROJECT : TEXT_UNFOLLOW_ALERT_PROJECT}
        redButtonText={TEXT_YES}
        onRedButtonClick={() => {
          handleSaveFollowClick(followFlag ? true : false);
        }}
        isLoading={isSaveLoading}
      />
    </div>
  );
};

export default SitesProjectSection;

